<template>
  <nav v-if="itemNews" class="nav__content article-header-layout">
    <div class="container">
      <article-header
        :title="itemNews.title"
        :share-url="itemNews.url"
        :articleDate="false"
        :isGoogleShare="false"
        class="article-header-layout--content"
      />
    </div>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useSectionsStore } from '@/stores/section'
import { storeToRefs } from 'pinia'

import ArticleHeader from '@/components/article/ArticleHeader.vue'

const sectionsStore = useSectionsStore()
const { itemsNewsDetails, pageSettings } = storeToRefs(sectionsStore)
const newsId = computed(() => pageSettings.value.id)
const itemNews = computed(() => itemsNewsDetails.value[newsId.value])
</script>

<style lang="scss">
@import '@/assets/scss/components/layout/article-header-layout';
</style>
